<template>
    <div>
        <v-card elevation="2" class="mb-4">
            <v-card-title>DOWNLOADER CACHE</v-card-title>
            <v-card-text>
                <v-alert type="warning" dense outlined class="mb-7">
                    <strong>Warning:</strong> This action will force all customers
                    who own this instrument to re-download its metadata and objectlist
                    the next time they load the Soundpaint downloader. Only use this
                    if customers need the instrument updates immediately. Otherwise, wait for the
                    natural 24-hour cache expiration to avoid unnecessary load on our database.
                </v-alert>
                <v-btn
                    color="primary"
                    small
                    @click="resetDownloaderCache"
                    :loading="resettingCache"
                    :disabled="resettingCache"
                >Reset Downloader Cache</v-btn>
            </v-card-text>
        </v-card>
        <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
            {{ snackText }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snack = false"> Close </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import fb from "@/main";

export default {
    props: ['instrumentId', 'instrumentName'],
    data() {
        return {
            resettingCache: false,
            snack: false,
            snackColor: "",
            snackText: "",
        };
    },
    async created() {
        this.store = this.$route.fullPath.split("/")[1];
    },
    methods: {
        async resetDownloaderCache() {
            try {
                const confirmed = confirm(
                    `Are you sure you want to reset the downloader cache for all customers who own "${this.instrumentName}"?`
                );

                if (!confirmed) {
                    return;
                }

                this.resettingCache = true;

                const resetDownloaderCustomerCache = fb.functions.httpsCallable("resetDownloaderCustomerCache");
                const result = await resetDownloaderCustomerCache({
                    store: this.store,
                    instrumentId: this.instrumentId,
                });

                this.resettingCache = false;
                this.snack = true;
                this.snackColor = "success";
                this.snackText = result.data.message;
            } catch (error) {
                console.error('Error resetting downloader cache:', error);
                this.resettingCache = false;
                this.snack = true;
                this.snackColor = "error";
                this.snackText = error.message || "Error resetting downloader cache";
            }
        },
    }
};
</script>
